<app-header [label]="'AI Admin'" [sub_label]="page_name"></app-header>

<div class="p-5 flex flex-col gap-4">

  <div class="flex flex-wrap items-end gap-3">
    <div class="w-52">
      <app-select-input label="University" [is_disabled]="gs.access_scope.locked.university" [(ngModel)]="params.university_id" [options]="university_options" (ngModelChange)="on_university_change()"></app-select-input>
    </div>
    <div class="w-44">
      <app-select-input label="Exam" [(ngModel)]="params.exam_id" [options]="exam_options" (ngModelChange)="on_exam_change()"></app-select-input>
    </div>
    <div class="w-44">
      <app-select-input label="Role" [(ngModel)]="params.role_id" [options]="role_options" (ngModelChange)="apply_filters()"></app-select-input>
    </div>
    <div class="ml-auto flex items-center gap-2">
      <input type="text" [(ngModel)]="params.search" (ngModelChange)="apply_filters()" placeholder="Search by name, ID" class="border border-gray-200 rounded-lg px-4 py-2 text-sm w-56 focus:outline-none focus:ring-2 focus:ring-[#3F41D1]/30" />
      <div class="flex items-center border border-gray-200 rounded-lg overflow-hidden">
        <button type="button" (click)="set_view_mode('grid')" [class]="view_mode === 'grid' ? 'px-3 py-2 bg-[#3F41D1] text-white' : 'px-3 py-2 bg-white text-gray-500 hover:bg-gray-50'">
          <i class="bx bx-grid-alt text-lg"></i>
        </button>
        <button type="button" (click)="set_view_mode('list')" [class]="view_mode === 'list' ? 'px-3 py-2 bg-[#3F41D1] text-white' : 'px-3 py-2 bg-white text-gray-500 hover:bg-gray-50'">
          <i class="bx bx-list-ul text-lg"></i>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="view_mode === 'grid'" class="grid grid-cols-6 gap-3">
    <div *ngFor="let item of items.data; trackBy: track_by_user_id" class="flex flex-col cursor-pointer" (click)="on_tile_click(item)">

      <!-- Video tile -->
      <div class="relative shadow-sm overflow-hidden aspect-square bg-gray-900" [class.border-red-500]="item.ai_triggered" [class.border-transparent]="!item.ai_triggered">

        <video [id]="'video-' + get_item_user_id(item)" autoplay muted playsinline class="w-full h-full object-cover"></video>

        <div *ngIf="item.ai_triggered" class="absolute top-2 left-2 z-10">
          <span class="flex items-center gap-1 bg-amber-500/90 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
            <i class="bx bx-error-circle text-sm"></i> AI
          </span>
        </div>

        <div *ngIf="get_item_status(item) === 'offline'" class="absolute inset-0 z-20">
          <img [src]="item.User?.image || 'assets/Profile.svg'" class="w-full h-full object-cover opacity-50" alt="">
          <div class="absolute inset-0 bg-white/20"></div>
          <div class="absolute bottom-3 right-2 w-9 h-9 rounded-full bg-[#E51E26] flex items-center justify-center shadow-md">
            <i class="bx bx-wifi-off text-white text-lg"></i>
          </div>
        </div>
      </div>

      <!-- Name below tile -->
      <p class="mt-1.5 truncate uppercase" style="font-family: 'Graphik', sans-serif; font-weight: 400; font-size: 12px; line-height: 1; letter-spacing: 0; color: #1e1e1e;">
        {{ get_item_name(item) }} ({{ get_item_user_id(item) }})
      </p>
    </div>

    <div *ngIf="items.data?.length === 0" class="col-span-6 flex flex-col items-center justify-center py-20 text-gray-400">
      <i class="bx bx-video-off text-5xl mb-3"></i>
      <p class="text-sm">No active sessions found</p>
    </div>
  </div>

  <app-ag-grid-list *ngIf="view_mode === 'list'" [list]="items" [colDefs]="columns" [show_checkboxes]="false" [itemName]="page_name" [rowHeight]="60" (fetch_new_list)="get_list($event)">
  </app-ag-grid-list>

</div>